import { useController, useFormContext } from "react-hook-form"
import { FormField } from "./types"
import MuiSlider, { type SliderProps } from "@mui/material/Slider"
import { FormControlLabel, FormGroup } from "@mui/material"
import cs from "classnames"
import { useDebouncedCallback } from "@react-hookz/web"
import { FormLabel } from "./FormLabel"
import { useDeleteCompanyMemberListMutation } from "platform-common/api/gql/generated/operations"
import { useEffect, useState } from "react"

export interface Props extends FormField, Pick<SliderProps, "min" | "max" | "marks" | "step"> {
  debounceFormUpdate?: number
  unit?: string
}

export const Slider = ({ name, rules, label, debounceFormUpdate, min, max, marks, step, unit, className }: Props) => {
  const { control } = useFormContext()
  const controller = useController({ name, control, rules })

  const defaultValue = controller.field.value ?? min
  const [_value, _setValue] = useState(defaultValue)

  const handleChangeInForm = useDebouncedCallback(
    (value: number | number[]) => {
      controller.field.onChange(value)
    },
    [],
    debounceFormUpdate ?? 0
  )

  const handleChange = (_: unknown, value: number | number[]) => {
    _setValue(value)
    handleChangeInForm(value)
  }

  return (
    <FormGroup>
      <FormControlLabel
        label={
          <FormLabel>
            {label} - {_value} {unit}
          </FormLabel>
        }
        control={
          <MuiSlider
            size="small"
            min={min}
            max={max}
            marks={marks}
            step={step}
            onChange={handleChange}
            defaultValue={defaultValue}
            className=""
          />
        }
        classes={{
          label: "!tmb-text-[25px]",
        }}
        className={cs("tmb-flex tmb-flex-1 tmb-flex-col-reverse tmb-items-start tmb-ml-0", className)}
      />
    </FormGroup>
  )
}

export default Slider
